import React, { ReactNode, useEffect, useState } from "react"
import VerifyAccModal from "components/Modal/VerifyAccModal"
import VerifyNotification from "components/VerifyNotification/VerifyNotification"
import { useUserContext } from "context/UserContext"
import { AnimatePresence } from "framer-motion"
import { useVerification } from "hooks/user/useVerification"
import { useShowNotification } from "hooks/user/useShowNotification"
import NewNavbar from "./NewNavbar"
import MobileMenu from "./MobileMenu"
import Footer from "components/Layout/Footer/Footer"
import FooterMobile from "components/Layout/FooterMobile/FooterMobile"

interface IProps {
    children: ReactNode
    noAnimation?: boolean
}

const MainLayout = ({ children }: IProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
    const { user } = useUserContext()

    const { verifyCookie } = useVerification()
    const { showNotification, setShowNotification } = useShowNotification(
        user,
        verifyCookie
    )

    useEffect(() => {
        // disable page scroll when menu is open
        // and enable it when menu is closed or if the route changes
        if (isMenuOpen) {
            document.body.style.overflow = "hidden"
        } else {
            document.body.style.overflow = "auto"
        }

        return () => {
            document.body.style.overflow = "auto"
        }
    }, [isMenuOpen])

    return (
        <>
            <AnimatePresence>
                {isMenuOpen && (
                    <MobileMenu
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                )}
            </AnimatePresence>

            {!verifyCookie && showNotification && (
                <VerifyNotification
                    setOpenModal={setOpenModal}
                    setShowNotification={setShowNotification}
                    isEmailVerified={user?.verification?.is_email_verified}
                    isPhoneVerified={user?.verification?.is_phone_verified}
                />
            )}

            <NewNavbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

            <VerifyAccModal
                setIsModalOpen={setOpenModal}
                isModalOpen={openModal}
            />

            {/* <LazyMotion features={domAnimation}>
                <m.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.25 }}
                > */}
            {children}
            {/* </m.div> */}
            {/* // </LazyMotion> */}

            <Footer />
            <FooterMobile />
        </>
    )
}

export default MainLayout
